import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import StringUtils from '../../conversations/utils/string';
import HeadshotComponent from './headshot';
import BrowserUtils from '../utils/browser';

const MessageCreator = ({ currentUser, conversationId, url, persistMessage, persistMessageCallback, parentId, closeReplyCreator, showNewReply }) => {
  const [message, setMessage] = useState('');
  const [subject, setSubject] = useState('');
  const [disabled, setDisabled] = useState(false);
  const [submitVisible, setSubmitVisible] = useState(false);

  const _textArea = useRef(null);

  const _isDesktop = BrowserUtils.isDesktop();

  const errors = false;

  useEffect(() => {
    resizeTextArea();
  }, [messageLength()]);

  function clearMessage() {
    if (subject.length) {
      setSubject('');
    }
    if (message.length) {
      setMessage('');
    }
  }

  function handleSubmit (e) {
    e.preventDefault();
    submitForm();
  }

  function submitForm() {
    const messageParams = { body: message, parentId };

    setDisabled(true);

    persistMessage(messageParams, url, { id: conversationId }).then(response => {
      clearMessage();
      setDisabled(false);
      response.message.parentId = response.message.parent_id;
      persistMessageCallback({ ...response.message, creator: currentUser });
      closeReplyCreator();
      showNewReply();
    });
  }

  function errorsDiv() {
    if (errors) {
      return (
        <div className="pull-left text-danger">{errors.join(', ')}</div>
      );
    }
  }

  function handleKeyDown (e) {
    if (((e.which || e.keyCode) === 13) && (e.ctrlKey || e.metaKey)) {
      if (!disableSubmit()) {
        submitForm();
      }
      e.preventDefault();
    }
  }

  function handleSubjectChange (e) {
    setSubject(e.target.value);
  }

  function handleChange (e) {
    if (!submitVisible) { setSubmitVisible(true); }
    setMessage(e.target.value);
  }

  function messageLength() {
    return StringUtils.trim(message).length;
  }

  function disableSubmit() {
    return disabled || messageLength() === 0;
  }

  function resizeTextArea() {
    const textArea = _textArea.current;

    if (textArea) {
      $(textArea).height('').innerHeight(textArea.scrollHeight);
    }
  }

  function focusTextArea() {
    const textArea = _textArea.current;

    if (textArea && _isDesktop) {
      $(textArea).focus();
    }
  }

  const renderSubject = () => {
    return (
      <input
        type="text"
        className="t3 form-control mb-10"
        placeholder="Subject"
        style={{ height: '51px' }}
        name="conversation_message[subject]"
        value={ subject }
        onChange={ handleSubjectChange }></input>
    );
  }

  const setAsSub = () => {
    return parentId ? 'subthread' : ''
  }

  return (
    <section className={ `message-box ${ setAsSub() }` }>
      {
        !conversationId
          ? null
          : <form
              className="new_conversation_message"
              id="new_conversation_message"
              action={ url }
              acceptCharset="UTF-8"
              method="post"
              onSubmit={ handleSubmit }>
                <input name="utf8" type="hidden" value="✓"/>
                <div className="conversation-message">
                  <HeadshotComponent user={ currentUser } width={ 44 } className="hidden-xs" />
                  <div className="form-container">
                    <textarea
                      className="t5 form-control autosize"
                      placeholder={ 'Write a reply' }
                      rows="1"
                      style={{ minHeight: '44px', height: '44px' }}
                      draggable="false"
                      name="conversation_message[body]"
                      value={ message }
                      onKeyDown={ handleKeyDown }
                      onChange={ handleChange }
                      ref={ _textArea }></textarea>
                    { errorsDiv() }
                  </div>
                  { submitVisible &&
                    <div className="message-creator-actions">
                      <input
                        type="submit"
                        name="commit"
                        value={ 'REPLY' }
                        className="submit btn-main pull-right"
                        data-disable-with="Send"
                        disabled={ disableSubmit() } />
                    </div>
                  }
                </div>
            </form>
      }
    </section>
  );
}

MessageCreator.propTypes = {
  persistMessage: PropTypes.func.isRequired,
};

export default MessageCreator;
